import { Component } from '@angular/core';
import { NavController, NavParams, ModalController, AlertController } from 'ionic-angular';
import { DataProvider } from '../../providers/data';
import { LoadingProvider } from '../../providers/loading';
import { FirebaseProvider } from '../../providers/firebase';
import { TeamappProvider } from '../../providers/teamapp';
import { UserProvider } from '../../providers/user';
import { MessagePage } from '../message/message';
import { ImageModalPage } from '../image-modal/image-modal';
import { Settings } from '../../settings';

@Component({
  selector: 'page-user-info',
  templateUrl: 'user-info.html'
})
export class UserInfoPage {
  private user: any;
  private userId: any;
  private friendRequests: any;
  private requestsSent: any;
  private friends: any;
  private alert: any;
  private teamapp_user: any;
  showJobTitle = Settings.showJobTitle;
  // UserInfoPage
  // This is the page where the user can view user information, and do appropriate actions based on their relation to the current logged in user.
  constructor(public navCtrl: NavController, public navParams: NavParams, public modalCtrl: ModalController, public dataProvider: DataProvider,
    public loadingProvider: LoadingProvider, public alertCtrl: AlertController, public firebaseProvider: FirebaseProvider, public teamappProvider: TeamappProvider, public userProvider: UserProvider) { }

  ionViewDidLoad() {

    this.userId = this.navParams.get('userId');
    console.log(this.userId);

    // Get user info.
    this.teamappProvider.http_request('firebase_token='+this.userId, 'profile', false, true).then(data => {
        this.teamapp_user = data;
        console.log(this.teamapp_user);
        this.loadingProvider.show();
        this.dataProvider.getUser(this.userId).snapshotChanges().subscribe((user) => {
            this.user = { $key: user.key, ...user.payload.val()};
            console.log(this.user);
            this.loadingProvider.hide();
        });
    });

    // Get friends of current logged in user.
    this.dataProvider.getUser(this.user).snapshotChanges().subscribe((user) => {
      if(user.payload.val() != null)
        this.friends = user.payload.val().friends;
    });
    // Get requests of current logged in user.
    this.dataProvider.getRequests(this.userProvider.getUserID()).snapshotChanges().subscribe((requests) => {
      console.log(requests.payload.val())
      if(requests.payload.val() != null){
        this.friendRequests = requests.payload.val().friendRequests;
        this.requestsSent = requests.payload.val().requestsSent;
      }
    });
  }

  block(){
    console.log("block function");


  }

  // Enlarge user's profile image.
  enlargeImage(img) {
    let imageModal = this.modalCtrl.create(ImageModalPage, { img: img });
    imageModal.present();
  }

  // Accept friend request.
  acceptFriendRequest() {
    this.alert = this.alertCtrl.create({
      title: 'Confirm Friend Request',
      message: '<b>' + this.user.name + '</b> als Freund akzeptieren?',
      buttons: [
        {
          text: 'Abbrechen',
          handler: data => { }
        },
        {
          text: 'Bestätigen',
          handler: () => {
            this.firebaseProvider.acceptFriendRequest(this.userId);
          }
        }
      ]
    }).present();
  }

  // Deny friend request.
  rejectFriendRequest() {
    this.alert = this.alertCtrl.create({
      title: 'Freundschaftsanfrage ablehnen',
      message: 'Do you want to reject <b>' + this.user.name + '</b> as your friend?',
      buttons: [
        {
          text: 'Abbrechen',
          handler: data => { }
        },
        {
          text: 'Ablehnen',
          handler: () => {
            this.firebaseProvider.deleteFriendRequest(this.userId);
          }
        }
      ]
    }).present();
  }

  // Cancel friend request sent.
  cancelFriendRequest() {
    this.alert = this.alertCtrl.create({
      title: 'Freundschaftsanfrage verschickt',
      message: '<b>' + this.user.name + '</b> eine Freundschaftsanfrage senden?',
      buttons: [
        {
          text: 'Abbrechen',
          handler: data => { }
        },
        {
          text: 'Löschen',
          handler: () => {
            this.firebaseProvider.cancelFriendRequest(this.userId);
          }
        }
      ]
    }).present();
  }

  // Send friend request.
  sendFriendRequest() {
    this.alert = this.alertCtrl.create({
      title: 'Freundschaftsanfrage senden',
      message: '<b>' + this.user.name + '</b> eine Freundschaftsanfrage senden?',
      buttons: [
        {
          text: 'Abbrechen',
          handler: data => { }
        },
        {
          text: 'Senden',
          handler: () => {
            this.firebaseProvider.sendFriendRequest(this.userId);
          }
        }
      ]
    }).present();
  }

  // Open chat with this user.
  sendMessage() {
    this.navCtrl.push(MessagePage, { userId: this.userId });
  }

  // Check if user can be added, meaning user is not yet friends nor has sent/received any friend requests.
  canAdd() {
    if (this.friendRequests) {
      if (this.friendRequests.indexOf(this.userId) > -1) {
        return false;
      }
    }
    if (this.requestsSent) {
      if (this.requestsSent.indexOf(this.userId) > -1) {
        return false;
      }
    }
    if (this.friends) {
      if (this.friends.indexOf(this.userId) > -1) {
        return false;
      }
    }
    if(this.user.userId == this.userId) {
      return false;
    }
    return true;
  }
}



// WEBPACK FOOTER //
// ./src/pages/user-info/user-info.ts